import { AllocationStatus, ArTranType, CreditArTranType, DebitArTranType } from '@anduin/api';
import { Range } from '@anduin/shared';
import moment from 'moment';

export interface TransactionsTableExternalFilters {
  dateRange: Range<string>;
  allocationStatuses: AllocationStatus[];
  clientIds: number[];
  /**
   * "My clients" tab. The queryable path sends `filter=MY_CLIENTS` and the backend resolves the caller's
   * staff id, so the request stays one param instead of an unbounded client-id list.
   */
  myClients: boolean;
  searchTerm: string;
  types: ArTranType[];
}

const DEFAULT_TRANSACTIONS_TABLE_EXTERNAL_FILTERS: TransactionsTableExternalFilters = {
  dateRange: { min: '', max: '' },
  allocationStatuses: [],
  clientIds: [],
  myClients: false,
  searchTerm: '',
  types: [],
};

export function getDefaultTransactionsTableExternalFilters(): TransactionsTableExternalFilters {
  const today = new Date();
  const dateRange: Range<string> = { min: moment(today).subtract(1, 'year').format('YYYY-MM-DD'), max: moment(today).format('YYYY-MM-DD') };

  return { ...DEFAULT_TRANSACTIONS_TABLE_EXTERNAL_FILTERS, dateRange };
}

export type NewTransactionType = DebitArTranType.DEBIT | DebitArTranType.LATE_FEE | CreditArTranType.CREDIT | CreditArTranType.RECEIPT;

export interface NewTransactionOption {
  type: NewTransactionType;
  display: string;
  labelId?: number;
}

/**
 * This helps simplify sidebar mode tracking. It's used to determine which sidebar mode to display and to manage transitions between modes.
 */
export enum TransactionsSidebarMode {
  VIEW = 'view', // an AR Tran is selected in the table
  EDIT = 'edit', // a selected AR Tran is being edited
  CREATE = 'create', // a new AR Tran is being created
}

export enum TransactionLinksMode {
  VIEW = 'view',
  EDIT = 'edit',
  AUTO = 'auto', // auto allocate
}
